<template>
  <div>
    <h2>{{titulo}}</h2>
    <b-row>
      <FormGroup
        cols="4"
        label="Sucursal">
        <v-select 
          @input="onChange"
          v-model="filtro.id_sucursal" 
          :clearable=false
          label="desc_sucursal"
          :options="this.$store.getters['usuario/getSucursalesFiltro']({id_sucursal:utils.mapAtributo(this.$store.state.usuario.sucursales, 'id_sucursal').toString(),desc_sucursal:'Todo'})" 
          :reduce="option=>option.id_sucursal">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Fecha inicio"> 
        <Datepicker @input="onChange" input-class="form-control" format="dd-MM-yyyy" v-model="filtro.fecha_i"></Datepicker>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Fecha término"> 
        <Datepicker @input="onChange" input-class="form-control" format="dd-MM-yyyy" v-model="filtro.fecha_t"></Datepicker>
      </FormGroup>
      <b-col cols="12" v-for="(objeto, key, index) in reporte.data" :key="index">
        <TablaReporte
          v-if="objeto.tipo == 'tabla'"
          :objeto="objeto"
          :titulo="objeto.titulo">
        </TablaReporte> 
        <BarraVerticalReporte
          v-if="objeto.tipo == 'barra'"
          :data="objeto"
          :titulo="objeto.titulo">
        </BarraVerticalReporte>
        <BarraHorizontalReporte
          v-if="objeto.tipo == 'barra_horizontal'"
          :data="objeto"
          :titulo="objeto.titulo">
        </BarraHorizontalReporte> 
        <LineaReporte
          v-if="objeto.tipo == 'linea'"
          :data="objeto"
          :titulo="objeto.titulo">
        </LineaReporte> 
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {formularioService} from "@/services";
import {utils} from "@/helpers";

import TablaReporte from '../../widgets/formulario/TablaReporte.vue';
import BarraVerticalReporte from '../../widgets/formulario/BarraVerticalReporte.vue';
import BarraHorizontalReporte from '../../widgets/formulario/BarraHorizontalReporte.vue';
import LineaReporte from '../../widgets/formulario/LineaReporte.vue';

export default {
  components: {TablaReporte, BarraVerticalReporte, BarraHorizontalReporte, LineaReporte},
  props:['titulo','id_reporte'],
  data() {
    return {
      loading: false,
      utils,
      filtro: {
        id_sucursal: utils.mapAtributo(this.$store.state.usuario.sucursales, 'id_sucursal').toString(),
        fecha_i: new Date(new Date().getFullYear(), new Date().getMonth(),1),
        fecha_t: new Date(),
        loading:true,
        id_reporte:this.id_reporte - 10000
      },
      reporte: {
        data:[]
      }
    }
  },
  mounted(){
    this.cargarDatos();
  },
  methods: {
    cargarDatos(){
      this.loading = true;

      formularioService.getFormularioReporteHistorial({
        id_sucursal: this.filtro.id_sucursal,
        id_reporte: this.filtro.id_reporte,
        fecha_i: utils.DateToFecha(this.filtro.fecha_i, 'dd-mm-yyyy'),
        fecha_t: utils.DateToFecha(this.filtro.fecha_t, 'dd-mm-yyyy'),
        id_usuario: this.$store.state.usuario.id_usuario,
        id_perfil: this.$store.state.usuario.perfiles.map((element) => element.id_perfil),
      }).then(respuesta => {
        this.reporte.data =  respuesta.data;

        this.loading = false;
      });
    },
    onChange(){
      this.cargarDatos();
    },
  }
}
</script>

<style scoped>
</style>
